import React, { useState } from 'react';
import Topnavigation from './Topnavigation';
import Footer from './Footer';
import SEO from './SEO';

const photos = [
  { src: './assets/img/upload/original_1.jpg', category: 'classroom', caption: 'Classroom Session' },
  { src: './assets/img/upload/original_2.jpg', category: 'events', caption: 'Annual Event' },
  { src: './assets/img/upload/original_3.jpg', category: 'events', caption: 'Prize Distribution' },
  { src: './assets/img/upload/original_4.jpg', category: 'classroom', caption: 'Study Session' },
  { src: './assets/img/upload/original_5.jpg', category: 'classroom', caption: 'Interactive Class' },
  { src: './assets/img/upload/original_6.jpg', category: 'events', caption: 'Cultural Program' },
  { src: './assets/img/upload/original_7.jpg', category: 'events', caption: 'Felicitation Ceremony' },
  { src: './assets/img/upload/original_12.jpg', category: 'classroom', caption: 'Group Study' },
  { src: './assets/img/upload/original_13.jpeg', category: 'classroom', caption: 'Practical Session' },
  { src: './assets/img/upload/1580387406_original.jpg', category: 'events', caption: 'Special Event' },
  { src: './assets/img/upload/1580387428_original.jpg', category: 'events', caption: 'Celebration' },
  { src: './assets/img/upload/1580387502_original.jpg', category: 'classroom', caption: 'Lecture Session' },
  { src: './assets/img/upload/1580387575_original.jpg', category: 'classroom', caption: 'Classroom Activity' },
  { src: './assets/img/upload/1607591102_original.jpg', category: 'events', caption: 'Award Ceremony' },
  { src: './assets/img/class00.jpg', category: 'classroom', caption: 'Class in Progress' },
  { src: './assets/img/class01.jpg', category: 'classroom', caption: 'Teaching Session' },
  { src: './assets/img/class02.jpg', category: 'classroom', caption: 'Student Activity' },
  { src: './assets/img/class03.jpg', category: 'classroom', caption: 'Group Discussion' },
  { src: './assets/img/slideg01.jpg', category: 'campus', caption: 'Campus View' },
  { src: './assets/img/slideg02.jpg', category: 'campus', caption: 'Study Environment' },
  { src: './assets/img/slideg03.jpg', category: 'campus', caption: 'Campus Facility' },
  { src: './assets/img/slideg04.jpg', category: 'campus', caption: 'Learning Space' },
  { src: './assets/img/slideg05.jpg', category: 'campus', caption: 'Campus Life' },
  { src: './assets/img/pens01.jpg', category: 'campus', caption: 'Study Corner' },
];

const filters = [
  { key: 'all', label: '🖼️ All Photos' },
  { key: 'classroom', label: '📚 Classroom' },
  { key: 'events', label: '🎉 Events' },
  { key: 'campus', label: '🏫 Campus' },
];

const Gallery = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [lightbox, setLightbox] = useState(null); // index of open image

  const filtered = activeFilter === 'all' ? photos : photos.filter(p => p.category === activeFilter);

  const openLightbox = (index) => setLightbox(index);
  const closeLightbox = () => setLightbox(null);
  const prevImage = () => setLightbox(i => (i - 1 + filtered.length) % filtered.length);
  const nextImage = () => setLightbox(i => (i + 1) % filtered.length);

  // Close on backdrop click
  const handleBackdrop = (e) => {
    if (e.target === e.currentTarget) closeLightbox();
  };

  return (
    <>
      <Topnavigation />
      <SEO
        title="Gallery - Photos & Events"
        description="View photos from Study-Link Coaching Classes - classrooms, events, campus life and student activities in Indore."
        keywords="study link gallery, coaching classes photos indore, student events indore"
        url="/gallery"
      />

      {/* Hero Banner */}
      <div style={{ position: 'relative' }}>
        <img
          src="./assets/img/bg_2.jpg"
          alt="Gallery"
          style={{ width: '100%', height: 'auto', maxHeight: 420, objectFit: 'cover' }}
        />
        <div style={{
          position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.6)',
          display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        }}>
          <h1 style={{ color: '#fff', fontWeight: 700, fontSize: 'clamp(26px, 5vw, 48px)', textAlign: 'center' }}>
            Photo Gallery
          </h1>
          <p style={{ color: '#ddd', fontSize: 'clamp(14px, 2vw, 18px)', textAlign: 'center', padding: '0 15px' }}>
            Moments from Study-Link Coaching Classes
          </p>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb" style={{ background: 'transparent', justifyContent: 'center', marginBottom: 0 }}>
              <li className="breadcrumb-item"><a href="/" style={{ color: '#009999' }}>Home</a></li>
              <li className="breadcrumb-item active" style={{ color: '#fff' }}>Gallery</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Gallery Section */}
      <section style={{ padding: '50px 0', background: '#f9f9f9' }}>
        <div className="container">
          <div className="text-center mb-4">
            <h2 style={{ fontWeight: 700, color: '#333' }}>Our Memories</h2>
            <div style={{ width: 60, height: 3, background: '#009999', margin: '10px auto 20px' }}></div>
            <p style={{ color: '#666', maxWidth: 550, margin: '0 auto' }}>
              A glimpse into life at Study-Link — classrooms, events, and campus moments.
            </p>
          </div>

          {/* Filter Tabs */}
          <div className="d-flex justify-content-center flex-wrap mb-4" style={{ gap: 10 }}>
            {filters.map(f => (
              <button
                key={f.key}
                onClick={() => setActiveFilter(f.key)}
                style={{
                  padding: '8px 22px', borderRadius: 30, fontWeight: 600, fontSize: 14,
                  border: '2px solid #009999', cursor: 'pointer', transition: 'all 0.3s',
                  background: activeFilter === f.key ? '#009999' : '#fff',
                  color: activeFilter === f.key ? '#fff' : '#009999',
                }}
              >
                {f.label}
              </button>
            ))}
          </div>

          {/* Photo Count */}
          <p style={{ textAlign: 'center', color: '#999', fontSize: 14, marginBottom: 24 }}>
            Showing {filtered.length} photo{filtered.length !== 1 ? 's' : ''}
          </p>

          {/* Photo Grid */}
          <div className="row">
            {filtered.map((photo, i) => (
              <div key={i} className="col-6 col-sm-4 col-lg-3 mb-4">
                <div
                  onClick={() => openLightbox(i)}
                  style={{
                    position: 'relative', overflow: 'hidden', borderRadius: 8,
                    cursor: 'pointer', boxShadow: '0 3px 12px rgba(0,0,0,0.1)',
                    transition: 'transform 0.3s, box-shadow 0.3s',
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.transform = 'translateY(-4px)';
                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,153,153,0.25)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 3px 12px rgba(0,0,0,0.1)';
                  }}
                >
                  <img
                    src={photo.src}
                    alt={photo.caption}
                    style={{ width: '100%', height: 180, objectFit: 'cover', display: 'block', transition: 'transform 0.4s' }}
                    onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.08)'}
                    onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                    onError={e => { e.currentTarget.src = './assets/img/class00.jpg'; }}
                  />
                  {/* Hover Overlay */}
                  <div style={{
                    position: 'absolute', inset: 0, background: 'rgba(0,153,153,0.7)',
                    display: 'flex', flexDirection: 'column',
                    alignItems: 'center', justifyContent: 'center',
                    opacity: 0, transition: 'opacity 0.3s',
                  }}
                    onMouseEnter={e => e.currentTarget.style.opacity = 1}
                    onMouseLeave={e => e.currentTarget.style.opacity = 0}
                  >
                    <span style={{ color: '#fff', fontSize: 28 }}>🔍</span>
                    <span style={{ color: '#fff', fontSize: 13, fontWeight: 600, marginTop: 6, textAlign: 'center', padding: '0 8px' }}>
                      {photo.caption}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {lightbox !== null && (
        <div
          onClick={handleBackdrop}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.92)',
            zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '20px',
          }}
        >
          {/* Close Button */}
          <button
            onClick={closeLightbox}
            style={{
              position: 'absolute', top: 15, right: 20,
              background: 'none', border: 'none', color: '#fff',
              fontSize: 36, cursor: 'pointer', lineHeight: 1, zIndex: 10,
            }}
          >
            &times;
          </button>

          {/* Prev Button */}
          <button
            onClick={prevImage}
            style={{
              position: 'absolute', left: 15, top: '50%', transform: 'translateY(-50%)',
              background: '#009999', border: 'none', color: '#fff',
              width: 44, height: 44, borderRadius: '50%', fontSize: 20,
              cursor: 'pointer', zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            ‹
          </button>

          {/* Image */}
          <div style={{ textAlign: 'center', maxWidth: '90vw' }}>
            <img
              src={filtered[lightbox].src}
              alt={filtered[lightbox].caption}
              style={{ maxWidth: '100%', maxHeight: '80vh', borderRadius: 8, objectFit: 'contain' }}
              onError={e => { e.currentTarget.src = './assets/img/class00.jpg'; }}
            />
            <p style={{ color: '#fff', marginTop: 12, fontSize: 16, fontWeight: 600 }}>
              {filtered[lightbox].caption}
            </p>
            <p style={{ color: '#aaa', fontSize: 13 }}>
              {lightbox + 1} / {filtered.length}
            </p>
          </div>

          {/* Next Button */}
          <button
            onClick={nextImage}
            style={{
              position: 'absolute', right: 15, top: '50%', transform: 'translateY(-50%)',
              background: '#009999', border: 'none', color: '#fff',
              width: 44, height: 44, borderRadius: '50%', fontSize: 20,
              cursor: 'pointer', zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            ›
          </button>
        </div>
      )}

      {/* CTA */}
      <section style={{ background: '#009999', padding: '50px 0' }}>
        <div className="container text-center">
          <h3 style={{ color: '#fff', fontWeight: 700, marginBottom: 12 }}>Want to Be Part of Our Story?</h3>
          <p style={{ color: 'rgba(255,255,255,0.85)', marginBottom: 25, fontSize: 16 }}>
            Join Study-Link and create your own memories with us.
          </p>
          <a href="/contact-us" className="btn" style={{
            background: '#fff', color: '#009999',
            padding: '12px 40px', borderRadius: 6, fontWeight: 700, fontSize: 16,
          }}>
            Enroll Now
          </a>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Gallery;
